import type { FaireProductEntity } from "../../entity_types/product";

export const p_5k9ug82es5: FaireProductEntity = {
  token: "p_5k9ug82es5",
  type: "product",
  name: "Marvella - Pumpkin Chai 10oz Candle - No Gift Box",
  brandToken: "b_85du58x7ja",
  brandName: "La Jolie Muse",
  imageUrl:
    "https://cdn.faire.com/fastly/f6211898e1491b324bf808d85b56f0450384f246c8681210c34325db7ccdeb9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1401d4c09556d6c10a4df4710950837c4ab311235c3eaaa484bbfe69f3ea01d8.jpeg",
    "https://cdn.faire.com/fastly/a4f3d207a548cfea9f75689f725407fca7e0f8c3a92b764ba2089d78f04d7095.jpeg",
    "https://cdn.faire.com/fastly/93504e7416ceb9aa274a5db7aeefad48e1db1bb1e78c1d48f022a735cf2650c4.jpeg",
    "https://cdn.faire.com/fastly/394f729087fa82677972f6ad42ad69676db723e3e5c956b5ff639dc9ba6fd35e.jpeg",
    "https://cdn.faire.com/fastly/f26d486e0e1006da4e4a7bde22941a6990bb246e9a2fc456034cbe35246ff52b.jpeg",
  ],
  priceDollars: 14,
  description:
    "Note: This La Jolie Muse Pumpkin Chai 10oz candle does not include an outer gift box or additional packaging. It is shipped as the candle only.\n\nThe Marvella Collection is a celebration of vibrant elegance and sophisticated charm, captured in the design of each candle jar. Drawing inspiration from classic and contemporary aesthetics, each jar is crafted from high-quality glass and adorned with a distinctive hobnail pattern. This intricate texture not only adds a tactile dimension but also enhances the visual appeal, creating a dynamic interplay of light and shadow when the candle is lit.\n\nWhen pumpkin mingled with sweet vanilla and warm chai, you will love this timeless spicy pleasure that should recall the autumn bliss and joy of harvest to fill your space with inviting vibes.\n\n• Top Notes: Plum\n• Heart/Middle Notes: Pumpkin, Spicy Chai\n• Base Notes: Warm Milk, Carmelized Vanilla",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:41:51.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
